import { connect } from 'react-redux';
import AwardsTable from 'account/components/payout/awards_table';
import { fetchPendingAwardsIfNeeded as fetch, filterAvailableAwards } from 'common/ducks/payout';
import { fetchCategoriesIfNeeded as fetchCategories } from 'common/ducks/categories';

const mapStateToProps = ({ payout, categories }, { onlyAvailable }) => {
  return {
    items: onlyAvailable? filterAvailableAwards(payout.pendingAwards) : payout.pendingAwards,
    categories: categories.data
  };
}

export default connect(mapStateToProps, {
  fetch,
  fetchCategories
})(AwardsTable);



// WEBPACK FOOTER //
// ./account/containers/payout/awards_table.js